import { MatSnackBar } from '@angular/material/snack-bar';

import { Router } from '@angular/router';

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Admin, AdminAction, AdminStatus } from 'sharedTypes/admin';
import { FirestoreService } from './firestore.service';
import {
    authState,
    getAuth,
    OAuthProvider,
    onIdTokenChanged,
    signInWithCustomToken,
    signInWithPopup,
    signOut,
    User,
} from '@angular/fire/auth';

@Injectable()
export class AuthService {
    private authstate: any;
    tabSessionId: any;

    user = new BehaviorSubject<User | null>(null);

    constructor(private firestoreService: FirestoreService, private router: Router, public snackBar: MatSnackBar) {
        authState(getAuth()).subscribe(async (auth: any) => {
            if (auth) {
                this.authstate = true;
                const user = await getAuth().currentUser;
                await this.saveAdminAction('login', '');
                this.user.next(user);
            } else {
                //
                this.authstate = false;
                this.user.next(null);
            }
        });
    }

    isAuthenticated() {
        return this.authstate;
    }

    async saveAdminAction(action: string, addInfo: string) {
        const na = new AdminAction();
        na.uid = this.getUid();
        na.atUnix = new Date().getTime();
        na.at = new Date().toISOString();
        na.action = action;
        na.addInfo = addInfo;
        na.id = this.firestoreService.createId();
        this.firestoreService.setFirestoreDocument('adminActions/' + na.id, na);
    }

    async saveAdminStatus(status: string) {
        const na = new AdminStatus();
        na.uid = this.getUid();
        na.atUnix = new Date().getTime();
        na.at = new Date().toISOString();
        na.status = status;
        na.id = this.firestoreService.createId();
        this.firestoreService.setFirestoreDocument('adminStatus/' + na.id, na);
    }

    loginWithToken(token: string) {
        signInWithCustomToken(getAuth(), token);
    }

    loginWithMicrosoft() {
        const provider = new OAuthProvider('microsoft.com');
        provider.setCustomParameters({
            prompt: 'consent',
            tenant: 'fd58dbdc-393a-4825-9630-0aea1437252e',
        });
        signInWithPopup(getAuth(), provider).then((data) => {});
    }

    async logout() {
        await this.router.navigate(['/']);
        signOut(getAuth()).then(() => {});
    }

    getUid() {
        return this.user.getValue()?.uid || '';
    }

    async getUserClaims(): Promise<Admin | null> {
        if (!this.user.getValue()) {
            return null;
        }
        return this.user.getValue()?.getIdTokenResult() as unknown as Admin;
    }
}
